import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KlientService } from '../http/klient.service';
import { TypKlienta } from '../../shared/models/klient.model';

@Injectable({
  providedIn: 'root'
})
export class HomeRedirectService {

  constructor(
    private klientService: KlientService,
    private router: Router
  ) { }

  getHomeRoute(): Observable<string> {
    return this.klientService.getKlient().pipe(
      map(klient => {
        switch (klient.typ) {
          case TypKlienta.KF:
            return '/pages/home-dg';
          case TypKlienta.KO:
            return '/pages/home-kh';
          case TypKlienta.KZ:
          default:
            return '/pages/przychody-koszty';
        }
      })
    );
  }

  redirectToHome(): void {
    this.getHomeRoute().subscribe(homeRoute => {
      this.router.navigate([homeRoute]);
    });
  }
}
